module.exports = __webpack_public_path__ + "img/IMG_8937.df70079c.jpg";